import { useState } from 'react';
import {
  ListModuleContentsData,
  ModuleContentType,
  sellerLearningCenterApiClient,
} from '@/api/seller/serv/oec_seller_learning_center_api';
import { CODE_SUCCESS } from '@features/constants/network';
import { getQuery } from '@i18n-ecom/lib/dist/commonjs/url';

export const useModuleLandingPageModel = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [err, setErr] = useState<boolean>(false);
  const [empty, setEmpty] = useState<boolean>(false);
  const [hotModuleData, setHotModuleData] = useState<ListModuleContentsData>();
  const [exploreData, setExploreData] = useState<ListModuleContentsData>();
  const configId = getQuery(location.search, 'config_id')?.toString() ?? '';

  const GetHotModule = async () => {
    const res = await sellerLearningCenterApiClient.ListModuleContents({
      module_config_id: Number(configId),
      module_content_type: ModuleContentType.Hot_content,
    });

    if (res.code === CODE_SUCCESS) {
      setHotModuleData(res?.data);
    } else {
      setErr(true);
    }
  };

  const GetExplore = async () => {
    const res = await sellerLearningCenterApiClient.ListModuleContents({
      module_config_id: Number(configId),
      module_content_type: ModuleContentType.Explore_More,
    });
    if (res.code === CODE_SUCCESS) {
      setExploreData(res?.data);
    } else {
      setErr(true);
    }
  };

  const fetchAll = () => {
    setErr(false);
    setEmpty(false);
    setLoading(true);
    if (configId) {
      Promise.all([GetHotModule(), GetExplore()])
        .then(res => {
          setLoading(false);
        })
        .catch(e => {
          setErr(true);
        });
    } else {
      setLoading(false);
      setErr(true);
    }
  };

  const errorText = {
    title: 'academy_load_fail_page_title',
    text: 'academy_load_fail_page_text',
    buttonText: 'academy_load_fail_page_btn',
    buttonClick: fetchAll,
  };

  const states = {
    loading,
    err,
    empty,
    errorText,
    hotModuleData,
    exploreData,
  };
  const actions = {
    fetchAll,
  };
  return {
    ...states,
    ...actions,
  };
};
